export const config = {
    showJustImage:false,
    title: "redez",
    image: "",
    showButton:false,
    navigationLinks:[
        { 
            routerLink:"home",
            fragment:"",
            text:"Inicio"
        },
        { 
            routerLink:"home",
            fragment:"about",
            text:"Acerca"
        },
        { 
            routerLink:"home",
            fragment:"projects",
            text:"Proyectos"
        },
        { 
            routerLink:"home",
            fragment:"signup",
            text:"Contactanos"
        }
    ],
    section1:{
        line1: "Redez",
        line2: "Un lugar de conexión, inspiración y ayuda para la comunidad hispana. ",
        line3: "Conéctate",
        fragment:"section3_line2",
        showButtons:true
    },
    section2:{
        line1: "Conéctate a nuestra red ",
        line2: 
        {
            sublines:[
                {text: "Redez es una plataforma para negocios, artistas locales, y organizaciones con trabajo importantes para la comunidad hispana."},
                {text: "Para registrar tu negocio, empresa, puesto de información, lo puedes hacer de la siguiente manera:"},
                {text: "Vía Zelle "},
                {text: "Costo $50"},
                {text: "Carmen González"},
                {text: "Email: grecia0214@icloud.com"},
                {text: "Número de teléfono: (787) 914-7560"},
            ]
        },
        img: "assets/img.redez.org/section.2.jpg"
    },
    section3: {
        line1:{ 
            title:"Conéctate",
            sublines:[
                {text: "Queremos conectar el talento abundante en la comunidad hispana de Louisville con las oportunidades ideales. Eso te incluye a ti! "}
            ],
            
            img: "assets/img.redez.org/section.3.1.jpg"
        },
        projects: [
            {
                title: "Negocios Local",
                text: "Vendes algún producto o servicio? Añade tu negocio a Redez para alcanzar más clientes y mejores contactos profesionales.",
                img: "assets/img.redez.org/section.3.2.jpg",
                class: ""
            },
            {
                title: "Organización",
                text: "Sirves a la comunidad? Comparte lo que tu haces y recluta a personas que se añadan a tu causa.",
                img: "assets/img.redez.org/section.3.3.jpg",
                class: "order-lg-first"
            },
            {
                title: "Artista",
                text: "Eres un creativo? Ya sea digital o físico, tu arte nos inspira! Comparte tu talento y crece tu negocio mientras haces lo que amas.",
                img: "assets/img.redez.org/section.3.4.jpg",
                class: ""
            }
        ],
        line2:{ 
            show:false,
            title:"Title",
            text: "Text",
            url:"URL"
        },
    },
    section4_5: {
        line1:"Suscríbete para recibir actualizaciones!",
        textbox: "Ingrese su dirección de correo electrónico..",
        button: "Suscríbete",
        confirmation: "Gracias por suscribirte!",
        cards: [
            {
                line1: "Address",
                line2: "NA",
                class: "fa-map-marked-alt"
            },
            {
                line1: "Email",
                line2: "nmolestina@lahoz.org",
                class: "fa-envelope"
            },
            {
                line1: "Phone",
                line2: "(502) 298-8771",
                class: "fa-mobile-alt"
            }
        ]
    },
    section6: {
        social_media:[
            {
                link:"https://www.facebook.com/redezlouisville",
                class:"fab fa-facebook-f"
            },
            {
                link:"https://www.instagram.com",
                class:"fab fa-instagram"
            }
        ]
    }
}